import { InjectionToken, Provider, Type } from '@angular/core';

export const TOAST_ALERTS_TOKEN = new InjectionToken<ToastAlertsAbstractService>('Toast alerts Service');

export interface ToastData {
  title: string;
  subtitle: string;
}

export abstract class ToastAlertsAbstractService {
  abstract success(data: ToastData): void;
  abstract info(data: ToastData): void;
  abstract warn(data: ToastData): void;
  abstract error(data: ToastData): void;
}

export function provideToastAlert(serviceImplementation: Type<ToastAlertsAbstractService>): Provider[] {
  return [
    {
      provide: TOAST_ALERTS_TOKEN,
      useExisting: serviceImplementation,
    },
  ];
}

// @deprecated, moved to ngx-tts
export enum AudioSpeed {
  VerySlow = 'verySlow',
  Slow = 'slow',
  Regular = 'regular',
  Fast = 'fast',
  VeryFast = 'veryFast',
}

export const AudioSpeedReverse = {
  [AudioSpeed.VerySlow]: 1,
  [AudioSpeed.Slow]: 2,
  [AudioSpeed.Regular]: 3,
  [AudioSpeed.Fast]: 4,
  [AudioSpeed.VeryFast]: 5,
};

export class IAIModel {
  modelName?: string;
  provider?: string;
  id?: string;
}

// Since it not clear if this bellows to chat AI Or user i put here.
export class ChatUserSettings {
  realTime: boolean; // For real time conversation chat, no need to press button to send message
  superHearing: boolean; // use whisper to get a better transcription
  repeatRecording: boolean; // depends on superhearing, if true, it will repeat the recording
  // fixGrammar: boolean; // fix grammar
  voice?: string; // first voice, when is not availible one
  // autoTranslate?: boolean; // auto translate
  highlightWords?: boolean; // highlight words
  synthVoice?: boolean; // post request to your own tts service to get audio, need resonse with standard
  model?: IAIModel; // if you want to use a specific model
  speed?: AudioSpeed; // if you want to use a specific speed variable
  speedRate?: number; // temporal for more specific speed.
  userMessageTask: boolean;
  assistantMessageTask: boolean;
}
